import theme from '~/theme/';

type BoundingBoxProps = {
  x1?: number;
  x2?: number;
  x3?: number;
  x4?: number;
  y1?: number;
  y2?: number;
  y3?: number;
  y4?: number;
  showHighLight?: boolean;
};

const BoundingBox = ({
  x1,
  x2,
  x3,
  x4,
  y1,
  y2,
  y3,
  y4,
  showHighLight,
}: Readonly<BoundingBoxProps>) => {
  const arrayOfX = [x1, x2, x3, x4];
  const arrayOfY = [y1, y2, y3, y4];

  const highestX = Math.max(...arrayOfX);
  const lowestX = Math.min(...arrayOfX);
  const highestY = Math.max(...arrayOfY);
  const lowestY = Math.min(...arrayOfY);
  const { colors } = theme;

  return (
    <div
      style={{
        position: 'absolute',
        top: `${lowestY * 100 - 1}%`,
        left: `${lowestX * 100 - 1}%`,
        width: `${(highestX - lowestX) * 100 + 2}%`,
        height: `${(highestY - lowestY) * 100 + 2}%`,
        border: showHighLight ? 'none' : `3px solid ${colors?.red[500]}`,
        backgroundColor: showHighLight ? `${colors?.red[500]}` : null,
        borderRadius: showHighLight ? 'none' : '0.3rem',
        boxShadow: showHighLight
          ? 'none'
          : `.1rem .1rem .3rem ${colors?.gray[500]}`,
      }}
    ></div>
  );
};

type HighlightAreaProps = {
  highlights?: any;
  pageNumber?: any;
  citations?: any;
  showHighLight?: boolean;
};

function HighlightArea(props: Readonly<HighlightAreaProps>) {
  const { pageNumber, citations, showHighLight } = props;

  return (
    <div>
      {citations != undefined && citations != null ? (
        citations
          .filter((citation) => citation.pageNumber === pageNumber)
          .map((citation) => (
            <BoundingBox
              key={JSON.stringify(citation)}
              showHighLight={showHighLight}
              {...citation}
            />
          ))
      ) : (
        <div />
      )}
    </div>
  );
}

export default HighlightArea;
